var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoomIllustration1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 125,
    height: 125,
    rx: 18.5,
    fill: "white",
    stroke: "#788BB1",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_260_11980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 64.2373L21.625 108.525C21.8498 109.931 23.0312 111 24.4375 111H58.5625C59.9688 111 61.1502 109.931 61.375 108.525L63.85 88.5936C63.1187 88.7062 62.3311 88.7621 61.4877 88.7621C50.6873 88.7621 32.4813 81 16 64.2373Z",
    fill: "#788BB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.855 107.298L109.786 101.096C107.523 94.3037 106.375 87.0382 106.375 79.875C106.375 75.2224 102.59 71.4375 97.9375 71.4375H86.6875C82.0349 71.4375 78.25 75.2224 78.25 79.875C78.25 87.0381 77.102 94.3035 74.8388 101.096L72.7707 107.298C72.4823 108.154 72.6278 109.099 73.1553 109.833C73.6852 110.566 74.534 111 75.4375 111H86.6875C87.6269 111 88.5057 110.53 89.0275 109.748L92.3125 104.82L95.5975 109.748C96.1193 110.53 96.9983 111 97.9375 111H109.188C110.091 111 110.94 110.566 111.47 109.833C111.997 109.099 112.143 108.155 111.855 107.298Z",
    fill: "#788BB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.75 43.3125C55.75 37.1079 50.5171 31.875 44.3125 31.875C38.1079 31.875 33.0625 37.1079 33.0625 43.3125C33.0625 49.5171 38.1079 54.5625 44.3125 54.5625C50.5171 54.5625 55.75 49.5171 55.75 43.3125Z",
    fill: "#788BB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1875 31.875C68.8474 31.875 72.625 28.0974 72.625 23.4375C72.625 18.7776 68.8474 15 64.1875 15C59.5276 15 55.75 18.7776 55.75 23.4375C55.75 28.0974 59.5276 31.875 64.1875 31.875Z",
    fill: "#788BB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3125 15C90.7579 15 89.5 16.2579 89.5 17.8125V60.1875H86.6875C85.1329 60.1875 83.875 61.4454 83.875 63V65.8125H100.75V63C100.75 61.4454 99.4921 60.1875 97.9375 60.1875H95.125V17.8125C95.125 16.2579 93.8671 15 92.3125 15Z",
    fill: "#788BB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.9751 78.3561C73.9751 73.6871 71.4438 67.95 66.4378 61.3125C65.8751 60.5812 65.0315 60.1875 64.1876 60.1875H19.9937C34.7312 75.3187 51.5876 83.1373 61.4878 83.1373C62.7251 83.1373 63.7376 83.025 64.5815 82.7998L66.044 71.1C67.5626 73.9687 68.3501 76.3875 68.3501 78.3561C68.3501 79.3121 68.3501 81.8998 64.5815 82.7996L63.8503 88.5936C70.1501 87.8623 73.9751 84.0936 73.9751 78.3561Z",
    fill: "#788BB1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_260_11980"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white",
    transform: "translate(16 15)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomIllustration1);
export default __webpack_public_path__ + "static/media/room-illustration1.dc266aef809cc0c1b67d20491c2caddf.svg";
export { ForwardRef as ReactComponent };